<div
  id="shive-calendar-control-bar"
  [ngClass]="CalendarView[calendarViewMode]"
  class="k-d-grid k-justify-content-between k-align-items-center"
>
  <div id="month-and-year" class="invert-scale k-d-flex">
    <div class="value-wrapper k-d-inline-flex k-align-items-baseline">
      <h3
        class="font-weight-bold k-m-0 text k-pr-3"
        [innerHTML]="calendarModel | monthAndYear"
      ></h3>
      <div class="k-pl-3">
        <h5 class="k-mb-0">
          <span>{{ calendarModel.calendarProperties.visibleStartDate | date: "dd.MM." }}</span> -
          <span>{{ calendarModel.calendarProperties.visibleEndDate | date: "dd.MM." }}</span>
        </h5>
      </div>
    </div>
  </div>

  <div id="worked-time" class="invert-scale k-text-center">
    <span class="small k-align-self-end k-mr-3" style="line-height: 1.5em">
      {{ controlBarService.getTitle() }}
    </span>
    <span id="total-time" class="k-ml-2">{{ accumulatedTimeMap | timeBlockAccumulatedWork }}</span>
  </div>

  <div
    id="time-and-controls"
    class="k-d-flex k-justify-content-start k-align-items-center invert-scale"
  >
    @if (calendarService.model.calendarViewMode === CalendarView.WeekGrid) {
      <div class="k-mr-7 k-w-max">
        KW <span class="k-font-weight-semibold">{{ String(weekIndex).padStart(2, "0") }}</span>
      </div>
    }

    <div id="controls" class="k-d-flex k-align-items-center">
      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="calendarInteractionService.prev()"
        class="k-mr-2.5"
        [svgIcon]="chevronLeftIcon"
      ></button>

      <a
        [routerLink]=""
        class="link-button k-text-center cursor-pointer"
        (click)="calendarInteractionService.today()"
        >Heute</a
      >

      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="calendarInteractionService.next()"
        [svgIcon]="chevronRightIcon"
        class="k-ml-3"
      ></button>

      <kendo-dropdownlist
        [data]="viewOptions"
        [value]="controlBarService.activeCalendarView"
        [valuePrimitive]="true"
        textField="text"
        valueField="value"
        (selectionChange)="controlBarService.switchView($event)"
        class="!k-ml-7 height-inherit !k-w-auto"
      ></kendo-dropdownlist>
    </div>
    <div
      id="tracking-controls"
      class="k-d-flex k-align-self-stretch k-ml-auto k-justify-content-end"
    >
      @if (trackerActive === true) {
        <ng-container [ngTemplateOutlet]="tracker"></ng-container>
      } @else if (trackerActive === false) {
        <ng-container [ngTemplateOutlet]="timer"></ng-container>
      } @else {
        <!-- Waiting for websocket check-->
        <div class="k-ml-2" style="white-space: nowrap">Waiting for tracker...</div>
      }
    </div>
  </div>
</div>

<ng-template #timer>
  @if (timerActiveTimeBlockId() === null) {
    loading...
  }
  @if (timerActiveTimeBlockId() !== null) {
    <div id="more-options" class="k-align-self-center k-mr-2.5">
      <a [routerLink]="" class="link-button k-text-center cursor-pointer">
        <fa-icon [icon]="faEllipsis" size="lg" class="turquoise" />
      </a>
    </div>
    <button
      kendoButton
      id="toggle-timer"
      (click)="
        activeTimeBlockTimerService.sharedTimerHandlerService.toggleTimer(this.buttonDisabled)
      "
      [disabled]="buttonDisabled"
      themeColor="base"
      rounded="full"
      class="k-p-0 k-ml-2 k-aspect-ratio-1 k-align-self-normal"
      [ngClass]="[timerActiveTimeBlockId() >= 0 ? 'stop' : 'play']"
      [class.k-button-solid-error-filled]="timerActiveTimeBlockId() >= 0"
      size="large"
    >
      @if (timerActiveTimeBlockId() < 0) {
        <fa-icon class="add k-text-white" [icon]="faPlay" [size]="'xs'"></fa-icon>
      }
      @if (timerActiveTimeBlockId() >= 0) {
        <fa-icon class="add k-text-white" [icon]="faStop" [size]="'xs'"></fa-icon>
      }
    </button>
  }
</ng-template>

<ng-template #tracker>
  <div id="tracker-active" class="k-ml-2 k-w-full k-pos-relative">
    <div
      class="icon k-pos-absolute"
      [ngClass]="trackerStatus() === TrackerStatus.Pause ? 'user-idle' : 'user-active'"
    >
      <fa-icon
        class="user-idle"
        [icon]="trackerStatus() === TrackerStatus.Pause ? faPause : faCircle"
      ></fa-icon>
    </div>
  </div>
</ng-template>
